import React from "react";
import WebsiteSettings from "../WebsiteSettings";

const WebsiteWidget = () => (
  <div className="widget-content-scroll">
    <WebsiteSettings />
  </div>
);

export default WebsiteWidget;
